const ACTIVE_STATUSES = ['open', 'pending', 'snoozed'];

export const getWorkQueueStatuses = (activeStatus, appliedFilters = []) => {
  if (!appliedFilters.length) {
    return ACTIVE_STATUSES.includes(activeStatus) ? [activeStatus] : [];
  }

  // Only status-only filters can use the queue API without silently dropping
  // other advanced criteria.
  if (appliedFilters.length !== 1) return [];
  const [filter] = appliedFilters;
  const statuses = Array.isArray(filter.values)
    ? filter.values.map(value => value.id ?? value)
    : [];
  return filter.attributeKey === 'status' &&
    filter.filterOperator === 'equal_to' &&
    statuses.length &&
    statuses.every(status => ACTIVE_STATUSES.includes(status))
    ? [...new Set(statuses)]
    : [];
};
